import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-veranstaltung-home-sichtbarkeit-festlegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleVeranstaltungHomeSichtbarkeitFestlegenEffects {

    RolleVeranstaltungHomeSichtbarkeitFestlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_VERANSTALTUNG_HOME_SICHTBARKEIT_FESTLEGEN),
        mergeMap((x: ac.PostRolleVeranstaltungHomeSichtbarkeitFestlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleVeranstaltungHomeSichtbarkeitFestlegen(x.rolleVeranstaltungHomeSichtbarkeitFestlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleVeranstaltungHomeSichtbarkeitFestlegenErfolgreichAction(result, x.rolleVeranstaltungHomeSichtbarkeitFestlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleVeranstaltungHomeSichtbarkeitFestlegenFehlerAction(error, x.rolleVeranstaltungHomeSichtbarkeitFestlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
